import { gql } from '@/__generated__';

export const REQUEST_GATE_MOVEMENT = gql(`#graphql
  mutation RequestGateMovement($input: RequestGateMovementInput!) {
    requestGateMovement(input: $input) {
      movement {
        ...GateMovementFragment
      }
    }
  }
`);
